module.exports = __webpack_public_path__ + "media/src/img/flags@2x-276410ffdcdd2ff8dca2477e71874903.png";